import { POINT_LOCATION } from '@/interfaces/map.interface'
import { Drawing, Orthophoto, PointCoordinates } from '@/interfaces/misc.interface'
import { OutdoorPlan, OrthoPhoto } from '@/interfaces/realEstate.interface'
import i18n from '@/i18n'

function coordinatesToPointCoordinates(coordinates: POINT_LOCATION): PointCoordinates {
  // only use first 2 coordinates, because that's how mapbox wants them
  return [coordinates.longitude, coordinates.latitude]
}
function getTitle(type: string, title?: string): string {
  const { t } = i18n.global

  if (title) {
    return title
  }
  const typeLowerCase = type.split('_')[0].toLowerCase()
  return t(`general__text__drawing-${typeLowerCase}`)
}

export function convertOutdoorPlanToDrawing(outdoorPlan: OutdoorPlan): Drawing {
  return {
    id: outdoorPlan.id,
    type: outdoorPlan.type,
    title: getTitle(outdoorPlan.type, outdoorPlan.title),
    northWest: coordinatesToPointCoordinates(outdoorPlan.northWest),
    northEast: coordinatesToPointCoordinates(outdoorPlan.northEast),
    southEast: coordinatesToPointCoordinates(outdoorPlan.southEast),
    southWest: coordinatesToPointCoordinates(outdoorPlan.southWest),
    storageFileName: outdoorPlan.storageFileName,
    tiledLayerUri: outdoorPlan.tiledLayerUri,
    visible: false
  }
}

export function convertFloorPlanToDrawing(floorPlan: any): Drawing {
  return {
    id: floorPlan.id,
    type: floorPlan.type,
    title: getTitle(floorPlan.type, floorPlan.title),
    northWest: floorPlan.northWest,
    northEast: floorPlan.northEast,
    southEast: floorPlan.southEast,
    southWest: floorPlan.southWest,
    storageFileName: floorPlan.storageFileName,
    tiledLayerUri: floorPlan.tiledLayerUri,
    visible: false
  }
}

export function convertOutdoorImageToOrthophoto(image: OrthoPhoto, index: number): Orthophoto {
  const { t } = i18n.global
  return {
    id: image.id,
    // type: image.type, // Currently doesn't exist and should not be necessary?
    title: image.title
      ? image.title
      : index !== 0
      ? t('general__view__orthophoto') + ' ' + index + 1
      : t('general__view__orthophoto'),
    northWest: coordinatesToPointCoordinates(image.northWest),
    northEast: coordinatesToPointCoordinates(image.northEast),
    southEast: coordinatesToPointCoordinates(image.southEast),
    southWest: coordinatesToPointCoordinates(image.southWest),
    storageFileName: image.storageFileName,
    tiledLayerUri: image.tiledLayerUri,
    visible: false
  }
}
